import { FilterSearchPayload } from "@/app/home/components/table/DataTable";
import { FactoryBillingRepo } from "@/core/repos/tables/factory-billing.repo";
import { WaterInvoiceRepo } from "@/core/repos/tables/water-invoice.repo";
import container from "@/lib/di/container";
import { Button, message, Modal, Progress } from "antd";
import dayjs from "dayjs";
import { useState, useEffect, Dispatch, SetStateAction } from "react";

const factoryBillingRepo = container.get(FactoryBillingRepo);
const waterInvoiceRepo = container.get(WaterInvoiceRepo);
interface ExportEInvoiceModalProps {
    isModalOpen: boolean,
    setIsModalOpen: Dispatch<SetStateAction<boolean>>,
    data: {
        total: number,
        filterMap: Map<string, FilterSearchPayload>
    }
}
export const ExportEInvoiceModal: React.FC<ExportEInvoiceModalProps> = ({ isModalOpen, setIsModalOpen, data }) => {
    const handleCancel = () => {
        setIsModalOpen(false);
    };
    const [loading, setLoading] = useState<boolean>(false);
    const [confirm, setConfirm] = useState<string>('');
    const process = async () => {
        const month = data.filterMap.get("month")?.value;
        const year = data.filterMap.get("year")?.value
        if (!month||!year) {
            message.error("Vui lòng chọn tháng và năm để xuất hoá đơn");
            return null;
        };
        const result = await waterInvoiceRepo.ExportEInvoiceAllAsync(month, year);
        if (result) {
            message.success("Xuất hoá đơn thành công");
        }

    }
    const handleSave = async () => {
        setLoading(true);
        await process();
        setIsModalOpen(false);
        setLoading(false);
    }
    return <Modal open={isModalOpen} onCancel={handleCancel} width={600}
        style={{
            top: 20
        }}
        styles={{
            mask: {
                backdropFilter: 'blur(2px)',
                backgroundColor: 'var(--primary-mask)'
            }
        }}
        footer={[
            <div key={1} className="w-full flex flex-row justify-end px-1.5">
                <Button key="submit" type="primary" loading={loading}
                    style={{
                        background: "var(--primary-color)",
                        paddingRight: 48,
                        paddingLeft: 48,
                        fontSize: 18,
                        fontWeight: 600,
                        paddingTop: 18,
                        paddingBottom: 18,
                    }} onClick={handleSave} >
                    Xác nhận
                </Button>
            </div>,
        ]}
    >
        <div className="flex flex-row w-full items-start justify-start select-none">
            <p className="ml-6 text-2xl font-bold text-primary">Xuất hoá đơn điện tử</p>
        </div>
        <div className="flex flex-col items-center">
            <div className="py-4 px-4 w-full">
              <div>Xuất {data.total} hoá đơn điện tử</div>
            </div>
        </div>
    </Modal>
} 